import { useTranslation } from 'react-i18next';
import React from 'react'
import { Button } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/erp_subpackage/components/YhBox'
import { useStockPoDetailModel } from '../backlogModel'

export const DataBox = () => {
    const { t } = useTranslation();
    const { exportOut, types, setType, resetSearchParam, loadData } = useStockPoDetailModel()

    const action = (
        <>
            <div style={{ marginBottom: '10px' }}>
                <Button
                    className="btn-item"
                    type="link"
                    shape="round"
                    onClick={() => {
                        setType(types.all)
                        resetSearchParam();
                        loadData({ pageSize: 15, current: 1 }, 'all', {})
                    }}
                >
                     {t(`stock.view.DataBox.汇总`)}
                </Button>
                <Button
                    className="btn-item"
                    type="link"
                    shape="round"
                    onClick={() => {
                        setType(types.detail)
                        resetSearchParam()
                        loadData({ pageSize: 15, current: 1 }, 'detail', {})
                    }}
                >
                     {t(`stock.view.DataBox.明细`)}
                </Button>
            </div>
            <Button
                className="btn-item"
                type="link"
                shape="round"
                onClick={() => {
                    exportOut()
                }}
            >
                 {t(`stock.view.DataBox.导出`)}
            </Button>
        </>
    )

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}
